import { render, staticRenderFns } from "./tanimlama.vue?vue&type=template&id=19c60a28&scoped=true&"
import script from "./tanimlama.vue?vue&type=script&lang=js&"
export * from "./tanimlama.vue?vue&type=script&lang=js&"
import style0 from "./tanimlama.vue?vue&type=style&index=0&id=19c60a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c60a28",
  null
  
)

export default component.exports